import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetJobMatchStatusComponent } from './set-job-match-status.component';
import { FormsModule } from '@angular/forms';
import { ExternalNotesModule } from '../../external-notes/external-notes.module';
import { PopoverModule, TooltipModule } from 'ngx-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { AiAssistantModule } from '../../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [SetJobMatchStatusComponent],
  imports: [
    CommonModule,
    FormsModule,
    ExternalNotesModule,
    TooltipModule,
    PopoverModule,
    NgSelectModule,
    PipesModule,
    AiAssistantModule
  ],
  exports: [SetJobMatchStatusComponent],
  entryComponents: [SetJobMatchStatusComponent]
})
export class SetJobMatchStatusModule { }
